// extracted by mini-css-extract-plugin
module.exports = {"root":"DealerDeck__root"};